import React, { useEffect, useState } from 'react';
//import Fullscreen from './Fullscreen'; // Assuming Fullscreen is a separate component
import 'feather-icons';
import { useSelector } from 'react-redux';
import { FaClipboard, FaEdit, FaFileAlt, FaShareAlt, FaDownload, FaArchive, FaTrashAlt, FaUndo, FaExpandArrowsAlt, FaCompressArrowsAlt, FaChartLine, FaChartBar } from 'react-icons/fa';
import '../styles/previewControl.css';

const ReportPreview = ({
  selectedReport,
  selectedReportName,
  selectedReportID,
  msgProof,
  isAdvancedOpen,
  showFullScreen,
  onSummary,
  onEdit,
  isFromReceipts,

  onShare,
  onDownload,
  onArchive,
  onArchiveUndo,
  onDelete,
  onFullScreenToggle,
  isFullscreen,
  showEditButton = true,
  showNotesButton = true,
  showShareButton = true,
  handleNotes,
  isSelectedBloodWork,
  handleClear,
  isReceipts,
  includeArchive
}) => {
  const isArchivedSelected = !!selectedReport?.is_archived;
  console.log(selectedReport, "selectedReport at previewControls")
  const [showDetails, setShowDetails] = useState(false);
  const userData = useSelector((state) => state.apiService.login);
  const menuData = useSelector((state) => state.apiService.sharedReportsValidateCode);

  const isProvider = userData.user_type_name === 'Provider';
  const isAccess = menuData.role === 'User';

  useEffect(() => {
    // Initialize Feather icons
    console.log(selectedReport, "selectedReport at previewControls")
    console.log(window.Feather, "window.Feather")
    if (window.Feather) {
      window.Feather.replace();
    } else {
      console.error("Feather icons not loaded");
    }
  }, [selectedReportID]);

  const handleToggleDetails = () => {
    setShowDetails((prev) => !prev);
  };

  return (
    <div className="col-12">
      <div className="row">
        <div className="col-lg-12 col-12  mb-0">
          <div className="row d-flex align-items-center">
            <h4 className="col-10 p-2 mb-0" style={{ whiteSpace: 'pre-line', wordBreak: 'break-all', fontSize: '18px', fontWeight: '500' }}>
              Preview of &nbsp;

              <span style={{ color: 'var(--pmr-secondary)' }}>{selectedReportName}</span>
            </h4>
            <div className="col-2 d-flex justify-content-end align-items-center">

              {selectedReportName && (
                <>
                  {!isFullscreen && (
                    <span onClick={handleClear} style={{ cursor: 'pointer', color: 'red', fontSize: '14px', fontWeight: '500', marginRight: '10px' }}>Clear</span>
                  )}
                  <span
                    onClick={onFullScreenToggle}
                    style={{ cursor: 'pointer' }}
                    title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}

                  >
                    {isFullscreen ? (
                      <FaCompressArrowsAlt className="font-medium-3 text-secondary" />
                    ) : (
                      <FaExpandArrowsAlt className="font-medium-3 text-secondary" />
                    )}
                  </span>
                </>
              )}
            </div>
          </div>

          {selectedReportName && (
            <div className="mt-25 row w-100">
              <span
                className="col-12 col-lg-4 preview-details-toggle d-flex justify-content-start align-items-center"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={handleToggleDetails}
              >
                {showDetails ? 'Hide details' : 'Show details'}
              </span>
              {!isProvider && !isFullscreen && (
                <div className="col-12 col-lg-8 d-flex justify-content-end align-items-center">
                  <div className="d-flex align-items-center justify-content-around preview-controls-icon-space">
                    {/* Show regular controls when report is not archived */}
                    {!isArchivedSelected && (
                      <>
                        {!isFromReceipts && (
                          <>
                            {isSelectedBloodWork && (
                              <span
                                onClick={() => onSummary(selectedReport)}
                                style={{ cursor: 'pointer' }}
                                title="Summary"
                                className="tooltip-icon"
                              >
                                <FaChartBar className="font-medium-3 text-primary" />
                              </span>
                            )}
                            {showEditButton && (
                              <span
                                style={{ cursor: 'pointer' }}
                                onClick={() => onEdit(selectedReport)}
                                title="Edit Report"
                                className="tooltip-icon"
                              >
                                <FaEdit className="font-medium-3 text-primary" />
                              </span>
                            )}
                            {showNotesButton && (
                              <span
                                onClick={() => handleNotes(selectedReport)}
                                title="Add Notes"
                                className="tooltip-icon"
                              >
                                <FaFileAlt className="font-medium-3 cursor-pointer text-warning" />
                              </span>
                            )}
                            {showShareButton && (
                              <span
                                onClick={() => onShare(selectedReport)}
                                title="Share Report"
                                className="tooltip-icon"
                              >
                                <FaShareAlt className="font-medium-3 cursor-pointer text-primary" />
                              </span>
                            )}
                          </>
                        )}
                        {(!isAccess || isFromReceipts) && (
                          <>
                            <span
                              onClick={() => onDownload()}
                              title={isFromReceipts ? "Download Receipt" : "Download Report"}
                              className="tooltip-icon"
                            >
                              <FaDownload className="font-medium-3 cursor-pointer text-primary" />
                            </span>
                            <span
                              onClick={() => onArchive(selectedReport.report_id || selectedReport.receiptId)}
                              title={isFromReceipts ? "Archive Receipt" : "Archive Report"}
                              className="tooltip-icon"
                            >
                              <FaArchive className="font-medium-3 cursor-pointer text-warning" />
                            </span>
                          </>
                        )}
                      </>
                    )}

                    {/* Show undo button when report/receipt is archived */}
                    {isArchivedSelected && (
                      <span
                        onClick={() => onArchiveUndo(selectedReport.report_id || selectedReport.receiptId)}
                        title={isFromReceipts ? "Restore Receipt" : "Restore Report"}
                        className="tooltip-icon"
                      >
                        <FaUndo className="font-medium-3 cursor-pointer text-primary" />
                      </span>
                    )}

                    {/* Show delete button for non-access users */}
                    {!isAccess && (
                      <span
                        onClick={() => onDelete()}
                        title={isFromReceipts ? "Delete Receipt" : "Delete Report"}
                        className="tooltip-icon"
                      >
                        <FaTrashAlt className="font-medium-3 cursor-pointer text-danger" />
                      </span>
                    )}
                  </div>
                </div>
              )}
              {showDetails && (
                <span className="col-12 col-lg-12">
                  <span className="col p-0 mr-1">
                    <strong className="preview-meta-label">Type:</strong> {selectedReport.group_name || selectedReport.category || (isReceipts ? 'Receipt' : 'NA')}
                  </span>
                  <span className="col p-0 mr-1">
                    <strong className="preview-meta-label ms-2">Provider:</strong> {selectedReport.provider_name || 'NA'}
                  </span>
                  {isAccess && (
                    <span className="col p-0 mr-1 px-1">
                      <strong className="preview-meta-label">Clinic:</strong> {selectedReport.hospital_name || 'NA'}
                    </span>
                  )}
                </span>
              )}

            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportPreview;
